import actionTypes from '../actionTypes/actionTypes';

const initialState = {
  categories: {}
}

function categoryReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_LOGIN:
      return Object.assign({}, state, {
        categories: action.categories
      })
    default:
      return state
  }
}

export default categoryReducer;